import store from '@/store/index';
import { fetchSession } from 'sociolla-analytics/actions/session';
const Config = require('~/config/default.env').default;

let lastUsedDomain = 0;

export default function setup() {
  // Add request interceptors
  axios.interceptors.request.use(
    (config) => {
      config.headers['SOC-PLATFORM'] = window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile';

      if (store.state.auth.token && store.state.auth.loggedin && !config.url.includes('amazonaws.com')) {
        config.headers.Authorization = `Bearer ${store.state.auth.token}`;
      }

      config.headers['session_id'] = fetchSession();

      if (config.url.startsWith(Config.MS_SOCO_PUBLIC_API_URL)) {
        config.url =
          Config.MS_SOCO_PUBLIC_API_LIST[lastUsedDomain] + config.url.substr(Config.MS_SOCO_PUBLIC_API_URL.length);
        lastUsedDomain = lastUsedDomain + 1 >= Config.MS_SOCO_PUBLIC_API_LIST.length ? 0 : lastUsedDomain + 1;
      }

      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );
}
